import { QuestionBase } from './question-base';

export class TextAreaQuestion extends QuestionBase<string> {
   ptctNo = 'textarea';
}
